// Enums.
import sexoCidadaoEnum from '@/enums/cadastro/cidadao/sexo'
import sexoSigtapEnum from '@/enums/sigtap/sexo'

export default (sexo, sexoPermitido) => {

    if (sexo === null) return null

    if (sexoPermitido === sexoSigtapEnum.INDEFINIDO) return true
    if (sexoPermitido === sexoSigtapEnum.NAO_SE_APLICA) return true

    let sexoProcedimento = sexoCidadaoEnum.MASCULINO

    if (sexoPermitido === sexoSigtapEnum.FEMININO) {

        sexoProcedimento = sexoCidadaoEnum.FEMININO
    }

    return sexo === sexoProcedimento
}